import ClientDialog from './ClientDialog';
import VendorDialog from './VendorDialog';
import CrewDialog from './CrewDialog';
import WorkTypeDialog from './WorkTypeDialog';
import ServiceIconsDialog from './ServiceIconsDialog';
import TaxCategoryDialog from './TaxCategoryDialog';
import QuoteDialog from './QuoteDialog';
import ConfirmDialog from './ConfirmDialog';

export {
  ClientDialog,
  CrewDialog,
  VendorDialog,
  WorkTypeDialog,
  ServiceIconsDialog,
  TaxCategoryDialog,
  QuoteDialog,
  ConfirmDialog,
};



// WEBPACK FOOTER //
// ./src/components/admin/Dialogs/index.js